import { NestedCheckboxItem } from '@components/nested-checkbox-list/src/nested-checkbox-list.type';
import { Channel, EventTeam, Team } from '@domain/eventTeam';

const formatTeamsToNestedCheckboxList = (teams: Team[]): NestedCheckboxItem[] =>
  teams.map((team: Team) => {
    const newObject: NestedCheckboxItem = {
      id: team.id,
      name: team.name,
      slug: team.name,
      children: team.channels.map((channel) => ({
        id: channel.channel.id,
        name: channel.channel.name,
        slug: channel.channel.slug,
        disabled: channel.isTicketSalesClosed,
        children: [],
      })),
    };
    return newObject;
  });

const formatChannelsWithoutTeamToNestedCheckboxList = (channels: Channel[]): NestedCheckboxItem[] =>
  channels.map((channel: Channel) => {
    return {
      id: channel.channel.id,
      name: channel.channel.name,
      slug: channel.channel.slug,
      disabled: channel.isTicketSalesClosed,
      children: [],
    };
  });

export const formatEventTeamsToNestedCheckboxList = (eventTeam: EventTeam): NestedCheckboxItem[] => {
  return Object.entries(eventTeam).reduce<NestedCheckboxItem[]>((acc, [key, value]) => {
    if (key === 'teams') {
      acc.push(...formatTeamsToNestedCheckboxList(value as Team[]));
    }
    if (key === 'channelsWithoutTeams') {
      acc.push(...formatChannelsWithoutTeamToNestedCheckboxList(value as Channel[]));
    }
    return acc;
  }, []);
};
